import { GoabBlock } from "@abgov/react-components";

import { useGenerationForm } from "../hooks/useGenerationForm";

export const FormValidationErrors = () => {
  const { form } = useGenerationForm();

  return (
    <>
      {Object.keys(form.errors).length > 0 && (
        <GoabBlock mb="m">
          <div style={{ color: "red" }}>
            <p>
              <strong>Please fix the following errors:</strong>
            </p>
            <ul>
              {Object.entries(form.errors).map(([key, value]) => {
                // Handle nested errors (like PersonalInformation.dob)
                if (typeof value === "object" && value !== null) {
                  return Object.entries(value as Record<string, any>).map(
                    ([nestedKey, nestedValue]) => (
                      <li key={`${key}.${nestedKey}`}>
                        <strong>
                          {key}.{nestedKey}:
                        </strong>{" "}
                        {String(nestedValue)}
                      </li>
                    )
                  );
                }
                return (
                  <li key={key}>
                    <strong>{key}:</strong> {String(value)}
                  </li>
                );
              })}
            </ul>
          </div>
        </GoabBlock>
      )}
    </>
  );
};
